import { Pipe, PipeTransform } from '@angular/core';
import * as Enumerable from 'linq';

@Pipe({
  name: 'columnWidth',
  standalone: true
})
export class ColumnWidthPipe implements PipeTransform {

  transform(columns: any[]): any {
    const widths = Enumerable.from(columns).select(x => x.width ? x.width : '1fr').toArray();
    return widths.join(' ');
  }

}

